import studentRequest from 'utils/studentRequest'

/**
 * The CV the candidate uploaded, resolved server-side.
 *
 * Screens carry the CV in three different shapes and some carry it not at all —
 * the drive candidate list, for one, never selected cvUrl — so the drawer asks
 * student-node rather than trusting whatever row it happens to hold. 404 is the
 * ordinary "never uploaded one" answer, not an error.
 *
 * @returns {Promise<string|null>} the URL, or null when there is none
 */
export const fetchUploadedCv = async (studentId, roleId) => {
  try {
    const response = await studentRequest.get(
      `/students/${studentId}/uploaded-cv`,
      { params: roleId ? { roleId } : {} }
    )
    return response?.data?.data?.url || null
  } catch (error) {
    if (error?.response?.status !== 404) {
      console.error('Unable to resolve the uploaded CV:', error)
    }
    return null
  }
}
